// styles
import styled from 'styled-components';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { actions as orderActions } from 'state/order';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import { constants as orderConstants } from 'utils/order';
import { useTranslation } from 'react-i18next';

const CustomCheckbox = styled.input`
  border: 1px solid green;
`;

const Label = styled.div`
  height: 16px;

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */
  user-select: none; /* Standard syntax */

  color: #54708c;
`;

const SoRecurringCheckbox = ({ className, candidate }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('Catalog');

  const onClick = useCallback(() => {
    dispatch(
      analyticsActions.sendEvent(
        analyticsEvents.form.orderTypeChanged({
          type: orderConstants.DIRECT_ORDER_RECURRING,
        })
      )
    );
    dispatch(orderActions.setRecurring({ isRecurring: true }));
    dispatch(push(routes.newOrder));
  }, [dispatch]);

  //   pickup

  return (
    <div className={className} onClick={onClick}>
      <CustomCheckbox type="checkbox" defaultChecked={false} />
      <Label>{t('configuration.recurring_order')}</Label>
    </div>
  );
};

export default styled(SoRecurringCheckbox)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 12px;

  height: 20px;
  /* border: 1px solid red; */
  /* height: 16px; */

  /* 14px/regular */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height, or 114% */

  /* grey / 700 */

  color: #54708c;
`;
